import HeatReportModal from "./heat-report-modal.vue";

export default HeatReportModal;



// WEBPACK FOOTER //
// ./src/components/_modals/heat-report/index.js